import script from "./FiltroDeCategorias.vue?vue&type=script&setup=true&lang=js"
export * from "./FiltroDeCategorias.vue?vue&type=script&setup=true&lang=js"

import "./FiltroDeCategorias.vue?vue&type=style&index=0&id=8a4181dc&scoped=true&lang=css"

import exportComponent from "/home/ewerson/Projetos/vue/vitrine_digital/vitrine-crescimentoc/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8a4181dc"]])

export default __exports__